const SanctionProposalSelector = ({
  loadingProposals,
  proposalsError,
  showProposals,
  sanctionProposals,
  selectedProposal,
  onProposalSelect,
}) => {
  return (
    <>
      {loadingProposals && (
        <div
          className="p-3 rounded mb-4 text-center"
          style={{
            background: "#f8f9fa",
            borderLeft: "4px solid #6c757d",
          }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Chargement...</span>
          </div>
          <p className="mt-2 mb-0" style={{ fontSize: 14 }}>
            Calcul des barèmes de sanction en cours...
          </p>
        </div>
      )}

      {proposalsError && (
        <div className="alert alert-warning mb-3" style={{ fontSize: 14 }}>
          <strong>⚠️ Attention :</strong> {proposalsError}
        </div>
      )}

      {showProposals && sanctionProposals.length > 0 && (
        <div
          className="p-3 rounded mb-4"
          style={{
            background: "#e7f3ff",
            borderLeft: "4px solid #007bff",
          }}
        >
          <h5 className="mb-2" style={{ fontSize: 14, color: "#004085" }}>
            📊 Proposition de sanction (calculée selon les motifs)
          </h5>
          <p className="mb-3" style={{ fontSize: 13, color: "#004085" }}>
            Le référent unique peut modifier cette proposition. Le président de
            séance pourra également la modifier lors de l'EP.
          </p>
          <div className="d-flex flex-column" style={{ gap: 8 }}>
            {sanctionProposals.map((proposal) => (
              <div
                key={proposal.id}
                className={`p-2 rounded border ${
                  selectedProposal === proposal.id
                    ? "bg-primary text-white"
                    : "bg-white"
                }`}
                style={{
                  cursor: "pointer",
                  transition: "all 0.2s",
                }}
                onClick={() => onProposalSelect(proposal.id)}
              >
                <span>{proposal.label} :</span>{" "}
                <strong>{proposal.description}</strong>
              </div>
            ))}
          </div>
          <p
            className="text-muted mt-2 mb-0"
            style={{ fontSize: 13, fontStyle: "italic" }}
          >
            Ces options sont calculées automatiquement en fonction des motifs
            sélectionnés et des antécédents EP de l'allocataire.
          </p>
        </div>
      )}
    </>
  );
};

export default SanctionProposalSelector;
